import React from 'react'
import "./Newproducts.css"
import {Data} from "../Data"
import FlashCards from "./FlashCards.js"

// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";

function NewProducts() {
  

  return (
    <>
    <div>
    <div className='fs-1 fw-bold container mt-lg-4 mt-md-3 mt-2 mb-2'>
    <img src='https://img.icons8.com/windows/32/fa314a/gift.png' className="mb-2" alt="no found" />
     <span  > New Products</span>
      </div>
     

      <div className=" mx-3">
  
   <FlashCards />
   
      </div>
      </div>
      </>
  )
}

export default NewProducts